module.exports = __webpack_public_path__ + "pc/img/body_basic-2.4e542110.png";